<template>
    <div v-if="show">
    
        <not-allowed v-if="!AllowedDisplay" :page="page" :module="idmodule" :data="datas"></not-allowed>

        <div class="pdf-actions">
            <v-btn small class="pdf-action" @click="recharge">Recharger</v-btn>
            <v-btn small class="pdf-action" @click="downloadFile">Télécharger</v-btn>
            <v-select
                v-if="translationEnabled"
                v-model="selectedLocale"
                :items="localeOptions"
                item-text="text"
                item-value="value"
                label="Langue"
                dense
                outlined
                hide-details
                class="pdf-locale-select"
            />
            <v-btn v-if="saveged" small class="pdf-action" @click="saveGed">Sauvegarder dans la GED</v-btn>
            <v-btn v-if="facturx && cansendpdp" small class="pdf-action" @click="sendPdp">Envoyer sur la plateforme</v-btn>
            <v-btn v-if="facturx" small class="pdf-action" @click="getXml">XML</v-btn>
        </div>
        <br>
            <iframe ref="monIframe" width="100%" height="600" :src="pdfUrl" v-if="typePage=='edit' || customparams || typePage=='page'">
            </iframe>
            <div v-if="typePage=='new'">Veuillez enregistrer le formulaire avant de voir le PDF</div>
            
    </div>
    </template>
    
    
    
    <script>

import api from "@/services/api";

import { client } from '../mixins'; 

        export default {

            name : 'pdfClient',

            mixins : [client],

            data: function() {
    
                return {
                    AllowedDisplay : true,
                    show : false,
                    pdfUrl : '',
                    datas : [],
                    displays : [],
                    saveged : false,
                    facturx : false,
                    cansendpdp : false,
                    documentname : '',
                    params:{},
                    querys:{},
                    translationEnabled : false,
                    localeOptions : [],
                    selectedLocale : 'fr',
                    localeInitialized : false,
                          // permet de définir si ce module est intégré dans une page form (nouvelle:newform ou en mode édition:editform), ou une page classique : page
                    typePage : (!this.$store.getters['listForm'](this.modalKey)) ? 'page' : this.$store.getters['listForm'](this.modalKey).typeform ,
                }
            },

        computed : {
            modEditForm() {
                return this.$store.getters['listForm'](this.modalKey);
            }
        },

        watch : {
            selectedLocale(newLocale, oldLocale) {
                if (!this.translationEnabled || !this.show || !oldLocale || newLocale === oldLocale) return
                this.refreshPdfUrl()
            },
            
            'modEditForm.typeform': {
                // permet de rafraichir quand la modal de modif du module de la page se ferme
                handler(newVal,oldVal) {
                    if(oldVal!='new') return;
                        this.typePage = newVal
                        this.initiateParams()
                        this.callAPI()
                },deep:true,
            },

        },

            methods :  {    
    
                callAPI : function() {
                    if(this.typePage=='new') return
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:this.params,querys:this.querys,locale:this.currentLocale()}}).then((resp) => {
                        this.manageDatas(resp.data)
                            
                    })
    
                },

                manageDatas(data) {
                    this.datas = data
                            if(!data.success) {
                            this.AllowedDisplay = false; 
                            return false;
                            }
                            this.saveged = data.saveged;
                            this.facturx = data.facturx;
                            this.cansendpdp = data.cansendpdp;
                            this.displays = data.displays
                            this.documentname = data.documentname;
                            this.configureTranslation(data.displays?.params?.translation)
                            this.pdfUrl = this.pdfRequestUrl()
                            this.show = true 
                },

                configureTranslation(translation) {
                    const config = translation && !Array.isArray(translation) ? translation : {}
                    const defaultLocales = [
                        { text: 'Français', value: 'fr' },
                        { text: 'Anglais', value: 'en' },
                        { text: 'Espagnol', value: 'es' },
                        { text: 'Allemand', value: 'de' },
                        { text: 'Italien', value: 'it' },
                        { text: 'Chinois simplifié', value: 'zh-CN' },
                    ]
                    this.translationEnabled = config.enabled === true
                    const configuredLocales = Array.isArray(config.locales) ? config.locales : []
                    this.localeOptions = defaultLocales.map(defaultLocale => {
                        return configuredLocales.find(locale => locale.value === defaultLocale.value) || defaultLocale
                    })

                    if (!this.localeInitialized) {
                        const defaultLocale = config.default || 'fr'
                        const localeExists = this.localeOptions.some(locale => locale.value === defaultLocale)
                        this.selectedLocale = localeExists || this.localeOptions.length === 0
                            ? defaultLocale
                            : this.localeOptions[0].value
                        this.localeInitialized = true
                    }
                },

                currentLocale() {
                    return this.translationEnabled ? this.selectedLocale : 'fr'
                },

                pdfRequestUrl(extraParams = {}, absolute = true) {
                    const query = new URLSearchParams({
                        token: this.$store.getters.getToken,
                        id: this.idmodule,
                        params: JSON.stringify(this.params),
                        locale: this.currentLocale(),
                        ...extraParams,
                    })
                    return (absolute ? api.defaults.baseURL : '')+'pdf?'+query.toString()
                },

                refreshPdfUrl(extraParams = {}) {
                    this.pdfUrl = ''
                    this.$nextTick(() => {
                        this.pdfUrl = this.pdfRequestUrl({ rebuild: Date.now(), ...extraParams })
                    })
                },

                saveGed() {
                    this.$store.dispatch('textOverlay','Transfert du document en cours');
                    this.$store.dispatch('getoverlay', true)
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,saveged:true,params:this.params,querys:this.querys,locale:this.currentLocale()}}).then((resp) => {
                        this.$store.dispatch('getoverlay', false)
                        if(!resp.data.success) {
                            this.$toast.error(resp.data.message)
                            return false;
                            }       
                            this.$toast.success(resp.data.message)                                     
                    })
                },
                sendPdp() {
                    this.$store.dispatch('textOverlay','Envoi du document en cours');
                    this.$store.dispatch('getoverlay', true)
                    this.API({type:'post', url:'displaymodule', params:{id:this.idmodule,params:{...this.params,sendpdp:true},querys:this.querys,locale:this.currentLocale()}}).then((resp) => {
                        this.$store.dispatch('getoverlay', false)
                        if(!resp.data.success) {
                            this.$toast.error(resp.data.message)
                            return false;
                            }
                            this.$toast.success(resp.data.message)
                    })
                },
                recharge() {
                    this.refreshPdfUrl()
                },
    

                downloadFile() {
                    this.API({type:'get',url:this.pdfRequestUrl({download:'1'}, false),apidefault:{responseType:'blob',headers:{'Accept':'application/pdf'}}}).then((resp) => {
                        const url = window.URL.createObjectURL(new Blob([resp.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        var name = (this.datas.displays.params.documentname) ? this.documentname : 'mon_pdf'
                        link.setAttribute('download', name+'.pdf');
                        document.body.appendChild(link);
                        link.click();
                    })
                    

                },   
                
                getXml() {
                    const xml = this.datas.xml.invoice||'';

                    const blob = new Blob([xml], {
                        type: 'application/xml'
                    });

                    const url = window.URL.createObjectURL(blob);

                    const a = document.createElement('a');
                    a.href = url;
                    a.download = 'invoice.xml';

                    document.body.appendChild(a);
                    a.click();

                    a.remove();
                    window.URL.revokeObjectURL(url);
                },

                initiateParams() {
                this.params = this.resolveModuleParams()
                this.querys = this.$store.getters.specificPage(this.modalKey).querys
                }
                
            },
            mounted() {
                this.initiateParams()
                let getdatas = this.$store.getters.getModuleDatas({page:this.modalKey,id:this.idmodule});
                if(getdatas) {
                    if(this.typePage=='new') return
                    this.reloadGed = true;
                    this.manageDatas(getdatas.datas)
                    this.$store.dispatch('removeModuleDatas',{page:this.modalKey,id:this.idmodule})
                } else {
                    this.callAPI() 
                } 
                if(this.typePage == 'edit' && this.querys.download == this.idmodule) {
                    this.downloadFile()
                }
            },
    
            created() {  

            }
    
        }
    
    </script>

    <style scoped>
    .pdf-actions {
        display: flex;
        align-items: center;
        flex-wrap: nowrap;
        gap: 6px;
        overflow-x: auto;
        padding: 4px 0;
    }

    .pdf-action {
        flex: 0 0 auto;
        font-size: 0.72rem;
    }

    .pdf-locale-select {
        flex: 0 0 145px;
        max-width: 145px;
    }
    </style>
